const formatCurrency = (symbol, value) => value.format(symbol + (value >= 1000 ? '0,0.0a' : '0,0a'));

export {
  formatCurrency
};
